const TRUSTED_NAMESPACES = ['gitlab-org', 'gitlab-com', 'gitlab-community', 'components'];

const ISSUE_URL_REGEX = new RegExp(
  `\\/(${TRUSTED_NAMESPACES.join('|')})\\/(.+?)\\/\\-\\/(issues|work_items)\\/(\\d+)$`,
);

const getMatch = (url, trustedHostname) => {
  try {
    const urlObj = new URL(url);
    if (urlObj.hostname !== trustedHostname) {
      return null;
    }

    const match = urlObj.pathname.match(ISSUE_URL_REGEX);
    if (!match) {
      return null;
    }

    return { urlObj, match };
  } catch {
    return null;
  }
};

export const isValidGitLabIssueUrl = (url, trustedHostname) => !!getMatch(url, trustedHostname);

export const parseGitLabIssueUrl = (url, trustedHostname) => {
  const result = getMatch(url, trustedHostname);
  if (!result) {
    return null;
  }

  const { urlObj, match } = result;
  const [, namespace, project, type, iid] = match;
  const projectPath = `${namespace}/${project}`;
  const encodedProjectPath = encodeURIComponent(projectPath);

  return {
    namespace,
    projectPath,
    type,
    iid,
    encodedProjectPath,
    apiUrl: `${urlObj.origin}/api/v4/projects/${encodedProjectPath}/issues/${iid}`,
  };
};
